import { render, staticRenderFns } from "./MyCommission.vue?vue&type=template&id=1d29193a&scoped=true"
import script from "./MyCommission.vue?vue&type=script&lang=js"
export * from "./MyCommission.vue?vue&type=script&lang=js"
import style0 from "./MyCommission.vue?vue&type=style&index=0&id=1d29193a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d29193a",
  null
  
)

export default component.exports